import { Truck } from 'lucide-react';
import type { TimelineBar as TimelineBarType } from './useTimelineData';

interface TimelineBarProps {
  bar: TimelineBarType;
}

export default function TimelineBar({ bar }: TimelineBarProps) {
  const left = bar.startMin;
  const width = Math.max(bar.endMin - bar.startMin, 2);
  // Use absolute times for tooltip display
  const startH = Math.floor(bar.absStartMin / 60);
  const startM = bar.absStartMin % 60;
  const endH = Math.floor(bar.absEndMin / 60);
  const endM = bar.absEndMin % 60;
  const timeStr = `${String(startH).padStart(2, '0')}:${String(startM).padStart(2, '0')} – ${String(endH).padStart(2, '0')}:${String(endM).padStart(2, '0')}`;

  return (
    <div
      className={`absolute top-1 bottom-1 rounded group cursor-default ${bar.isDedicated ? 'ring-2 ring-orange-400' : ''}`}
      style={{
        left,
        width,
        backgroundColor: bar.color,
        opacity: 0.85,
      }}
    >
      {width > 40 && (
        <span className="text-[10px] text-white px-1 truncate block leading-6">
          {bar.merchantName}
        </span>
      )}
      <div className="hidden group-hover:block absolute bottom-full left-1/2 -translate-x-1/2 mb-1 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-nowrap z-30 pointer-events-none">
        <div className="font-semibold">{bar.merchantName}</div>
        <div>
          {bar.slotCode}
          {bar.slotLabel ? ` · ${bar.slotLabel}` : ''} — {timeStr} ({bar.durationMin} min)
        </div>
        {bar.isDedicated && (
          <div className="flex items-center gap-1 text-orange-300 mt-0.5">
            <Truck className="h-3 w-3" />
            {bar.dedicatedDriverName ?? 'Dedicated · no PA assigned'}
          </div>
        )}
      </div>
    </div>
  );
}
